<!-- eslint-disable prettier/prettier -->
<!-- eslint-disable prettier/prettier -->
<template>
  <KeepAlive>
    <div class="main-pages">
      <loading :active.sync="isLoading" :is-full-page="true"></loading>

      <div class="w-100" style="margin-top: 82px; padding: 24px">
        <span class="pageSteps card-styling col-12">
          <div class="col-10 col-md-11">
            <p style="font-weight: 300; font-style: normal; margin: 0">
              Dashboard
            </p>
          </div>
          <div class="col-2 col-md-1">
            <a @click="getReport()" id="relatorioXls">
              <img
                :src="require('@/assets/images/svg/icone-baixar.svg')"
                class="img-fluid cursor-pointer"
                style="margin-right: 20%"
                alt=""
                title="Baixar relatório"
            /></a>
            <img
              v-b-toggle.sidebar-right
              :src="require('@/assets/images/svg/icone-filtro.svg')"
              class="img-fluid cursor-pointer"
              alt=""
              title="Filtro postagens"
            />
          </div>
        </span>
        <section
          v-if="dash"
          style="margin-top: 32px"
          class="d-flex flex-column justify-content-between align-items-center w-100"
        >
          <div class="d-flex w-100 session-one">
            <CardPrimary
              :filter="filterPhrase"
              :kind="'follow'"
              :value="dash.followers"
              :value2="dash.followersRangePercent"
            />

            <CardPrimary
              :filter="filterPhrase"
              :kind="'followRange'"
              :value="dash.followersRange"
              :value2="dash.followersRange"
            />

            <CardPrimary
              :filter="filterPhrase"
              :kind="'likes'"
              :value="dash.mediaFeedInsights.likes"
            />

            <CardPrimary
              :filter="filterPhrase"
              :kind="'comments'"
              :value="dash.mediaFeedInsights.commentsCount"
            />
          </div>
        </section>
        <section
          v-if="dash"
          style="margin-top: 32px"
          class="d-flex flex-column justify-content-between align-items-center w-100"
        >
          <div class="d-flex w-100 session-one">
            <CardPrimary
              :filter="filterPhrase"
              :kind="'visits'"
              :value="dash.profileViews"
            />
            <CardPrimary
              :filter="filterPhrase"
              :kind="'clicks'"
              :value="dash.clicks"
            />
            <CardPrimary
              :filter="filterPhrase"
              :kind="'shares'"
              :value="dash.mediaFeedInsights.shares"
            />
            <CardPrimary
              :filter="filterPhrase"
              :kind="'saves'"
              :value="dash.mediaFeedInsights.saves"
            />
          </div>
        </section>
        <section
          style="margin-top: 32px"
          class="d-flex flex-column justify-content-between align-items-center w-100"
        >
          <div class="d-flex w-100 session-one">
            <div
              class="col-lg-5 col-12 justify-content-between d-flex flex-column"
            >
              <div class="card-dash">
                <p class="p-card" style="font-size: 20px">Últimos comentários</p>
                <div
                  class="col-12"
                  style="margin-top: 10px"
                  v-for="item in comments.data"
                  :key="item.id"
                >
                  <div class="d-flex col-12">
                    <div class="col-12 d-flex">
                      <img
                        :src="require('@/assets/images/svg/avatar-default.svg')"
                        class="img-fluid"
                        style="max-width: 12%"
                        alt="imagem perfil"
                      />
                      <p class="p-comentario" style="margin-left: 10px">
                        <b style="color: black">{{ item.instaUserName }}</b>
                        {{ item.text }}
                      </p>
                    </div>
                  </div>
                  <div class="d-flex col-12">
                    <div class="col-md-8 col-8">
                      <p class="p-comentario" style="margin-left: 22%">
                        {{ currentDateTime(item.timestamp) }}
                      </p>
                    </div>
                    <div class="col-md-4 justify-content-start">
                      <router-link
                        :to="{
                          name: 'Details',
                          params: { id: item.instaMediaId },
                        }"
                      >
                        <button class="btn-card">Responder</button>
                      </router-link>
                    </div>
                  </div>
                </div>
                <br />
                <div class="justify-content-end">
                  <router-link
                    style="text-decoration: none"
                    :to="{ name: 'Posts' }"
                  >
                    <p class="a-vermais">Veja mais ></p>
                  </router-link>
                </div>
              </div>
            </div>
            <div v-if="dash" class="col-lg-2 col-12 d-flex flex-column">
              <div class="card-dash">
                <p class="text-center p-card">Alcance Total da Conta</p>
                <h2 class="text-center h2-card">
                  {{ formataNumeros(dash.mediaFeedInsights.reach) }}
                </h2>
                <img
                  :src="require('@/assets/images/svg/grafico-default.svg')"
                  class="img-fluid"
                  alt="Grafico"
                />
              </div>
              <div class="card-dash" style="margin-top: 32px">
                <p class="text-center p-card">Total de Impressões da Conta</p>
                <h2 class="text-center h2-card">
                  {{ formataNumeros(dash.mediaFeedInsights.impressions) }}
                </h2>
                <img
                  :src="require('@/assets/images/svg/grafico-default.svg')"
                  class="img-fluid"
                  alt="Grafico"
                />
              </div>
              <div class="card-dash" style="margin-top: 32px">
                <p class="text-center p-card">Total de publicações</p>
                <h2 class="text-center h2-card">
                  {{ formataNumeros(dash.mediaCount) }}
                </h2>
                <img
                  :src="require('@/assets/images/svg/grafico-default.svg')"
                  class="img-fluid"
                  alt="Grafico"
                />
              </div>
            </div>
            <div
              class="col-lg-5 col-12 justiy-content-between d-flex flex-column"
            >
              <div class="card-dash">
                <p class="p-card" style="font-size: 20px">Postagens polulares</p>

                <div
                  class="col-12 d-flex cursor-pointer"
                  style="margin-top: 15px"
                  v-for="item in filtraPostagens"
                  :key="item.id"
                  @click="
                    () => {
                      recebeID = item;
                      redirectPost();
                    }
                  "
                >
                  <div class="d-flex col-10">
                    <img
                      v-if="
                        item.mediaType === 'IMAGE' ||
                        item.mediaType === 'CAROUSEL_IMAGE'
                      "
                      :src="item.mediaUrl"
                      class="img-fluid"
                      style="max-width: 15%; border-radius: 8px; max-height: 90%"
                      alt="imagem perfil"
                    />

                    <video
                      v-else
                      :src="item.mediaUrl"
                      class="img-fluid"
                      style="max-width: 15%; border-radius: 8px; max-height: 90%"
                      alt="video perfil"
                    />
                    <p class="p-comentario short-text" style="margin-left: 10px">
                      <b style="color: black">{{ item.caption }}</b> <br />
                      {{ item.username }}
                      <img
                        v-if="item.username"
                        :src="require('@/assets/images/svg/seta.svg')"
                        class="img-fluid"
                        style="max-width: 3%"
                        alt="imagem seta"
                      />
                    </p>
                  </div>
                  <div class="col-2">
                    <b style="color: black">{{ item.impressionsCount }}</b> <br />
                    <p class="p-comentario">Impressões</p>
                  </div>
                </div>
                <br />
                <div class="justify-content-end">
                  <router-link
                    style="text-decoration: none"
                    :to="{ name: 'Posts' }"
                  >
                    <p class="a-vermais">Veja mais ></p>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          v-if="dash"
          style="margin-top: 32px"
          class="d-flex flex-column justify-content-between align-items-center w-100"
        >
          <div class="d-flex w-100 session-one">
            <div
              class="col-lg-12 col-12 card-styling justify-content-between d-flex flex-column"
            >
              <p class="p-card" style="font-size: 20px">Stories</p>
              <div class="col-12">
                <div class="d-flex session-one">
                  <div
                    class="col-lg-3 col-12 col-md-6 justify-content-between d-flex flex-column"
                  >
                    <p class="text-center p-card">Alcance</p>
                    <h2 class="text-center h2-card">
                      {{ formataNumeros(dash.mediaStoryInsights.reach) }}
                    </h2>
                  </div>
                  <div
                    class="col-lg-3 col-12 col-md-6 justify-content-between d-flex flex-column"
                  >
                    <p class="text-center p-card">Impressões</p>
                    <h2 class="text-center h2-card">
                      {{ formataNumeros(dash.mediaStoryInsights.impressions) }}
                    </h2>
                  </div>
                  <div
                    class="col-lg-3 col-12 col-md-6 justify-content-between d-flex flex-column"
                  >
                    <p class="text-center p-card">Visualizações</p>
                    <h2 class="text-center h2-card">
                      {{ formataNumeros(dash.mediaStoryInsights.impressions) }}
                    </h2>
                  </div>
                  <div
                    class="col-lg-3 col-12 col-md-6 justify-content-between d-flex flex-column"
                  >
                    <p class="text-center p-card">Interações</p>
                    <h2 class="text-center h2-card">
                      {{ formataNumeros(dash.mediaStoryInsights.totalInteractions) }}
                    </h2>
                  </div>
                </div>
              </div>
              <div class="col-12" style="margin-top: 32px">
                <div class="d-flex session-one">
                  <div
                    class="col-lg-3 col-12 col-md-6 justify-content-between d-flex flex-column"
                  >
                    <p class="text-center p-card">Saída</p>
                    <h2 class="text-center h2-card">
                      {{ formataNumeros(dash.mediaStoryInsights.exits) }}
                    </h2>
                  </div>
                  <div
                    class="col-lg-3 col-12 col-md-6 justify-content-between d-flex flex-column"
                  >
                    <p class="text-center p-card">Voltar</p>
                    <h2 class="text-center h2-card">
                      {{ formataNumeros(dash.mediaStoryInsights.tapsBack) }}
                    </h2>
                  </div>
                  <div
                    class="col-lg-3 col-12 col-md-6 justify-content-between d-flex flex-column"
                  >
                    <p class="text-center p-card">Avançar</p>
                    <h2 class="text-center h2-card">
                      {{ formataNumeros(dash.mediaStoryInsights.tapsForward) }}
                    </h2>
                  </div>
                  <div
                    class="col-lg-3 col-12 col-md-6 justify-content-between d-flex flex-column"
                  >
                    <p class="text-center p-card">Respostas</p>
                    <h2 class="text-center h2-card">
                      {{ formataNumeros(dash.mediaStoryInsights.replies) }}
                    </h2>
                  </div>
                </div>
              </div>  
            </div>
          </div>
        </section>
      </div>
      <ModalSidebar
        @onUpdateSete="(data) => setDataFilter(data)"
        @onUpdateTrinta="(data) => setDataFilter(data)"
        @onUpdateVinteQuatro="(data) => setDataFilter(data)"
        @onUpdatePersonalizado="(data) => setDataFilter(data)"
        @filter="getTime(), getStoryTime()"
      />
    </div>
  </KeepAlive>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import moment from "moment/moment";
import ModalSidebar from "../components/modalSidebar.vue";
import apiGerenciarMidias from "../service/apiGerenciarMidiasService";
import Loading from "vue-loading-overlay";
import CardPrimary from "../components/cards/CardPrimary";

const barrel = parseInt(process.env.VUE_APP_LIMIT_QUERY);

export default {
  name: "Dashboard",
  components: {
    ModalSidebar,
    Loading,
    CardPrimary,
  },
  data() {
    return {
      comments: {
        data: [],
      },
      filtros: {},
      story: {
        data: [],
      },
      dateStartFilter: undefined,
      dateEndFilter: undefined,
      medias: {
        data: [],
      },
      recebeID: {},
      dash: null,
      isLoading: false,
      selectedFilterType: "",
      filterPhrase: "nos últimos 7 dias",
    };
  },
  computed: {
    ...mapGetters(["getSelectedStores", "getFilterTypes"]),

    filtraPostagens() {
      if (Object.keys(this.medias).length > 0) {
        return this.medias.data.filter((m) => m.mediaProductType != "STORY");
      } else {
        return "";
      }
    },
    formataInteracoes() {
      return (
        this.formataRespostas +
        this.formataEmcaminhamento +
        this.formataImpressions
      );
    },
  },

  async created() {
    this.isLoading = true;
    let storesSelected = Array.from(this.getSelectedStores);
    // await this.getMedias();
    if (storesSelected.length != 0) await this.getStored(storesSelected);
    await this.getCommets();
    await this.getStories();

    this.isLoading = false;
  },
  watch: {
    async getSelectedStores(stores) {
      try {
        this.isLoading = true;

        await this.getStored(stores);
        await this.getCommetsFilter(stores);
        await this.getmediaFilter(stores);
        await this.getstoryFilter(stores);
      } finally {
        this.isLoading = false;
      }
    },
  },
  methods: {
    ...mapActions([
      "getdash",
      "getcommets",
      "getmedia",
      "getstory",
      "setFilterType",
    ]),
    ...mapMutations(["SET_STORES"]),

    formataNumeros(value) {
      let valueNumber = value.toString();

      if (valueNumber.length === 4) {
        return valueNumber.substring(0, 1) + "." + valueNumber.substring(1);
      } else if (valueNumber.length === 5) {
        return valueNumber.substring(0, 2) + "." + valueNumber.substring(2);
      } else if (valueNumber.length === 6) {
        return valueNumber.substring(0, 3) + "." + valueNumber.substring(3);
      } else if (valueNumber.length === 7) {
        return valueNumber.substring(0, 1) + "." + valueNumber.substring(1);
      } else if (valueNumber.length === 8) {
        return valueNumber.substring(0, 3) + " Milhões";
      } else if (valueNumber.length === 9) {
        return valueNumber.substring(0, 1) + " Bilhões";
      } else {
        return valueNumber;
      }
    },

    setDataFilter(obj) {
      let filter = this.getFilterTypes;

      this.dateStartFilter = obj.date.start;
      this.dateEndFilter = obj.date.end;

      filter.type = obj.type;
      filter.date.start = obj.date.start;
      filter.date.end = obj.date.end;

      this.setFilterType(filter);
    },
    formartValue(value) {
      return value.toLocaleString("pt-BR");
    },
    redirectPost() {
      this.$router.push({
        name: "Details",
        params: { id: this.recebeID.instaMediaId },
      });
    },
    async getStored(stores) {
      await this.getdash({
        isByName: true,
        start: false,
        isTime: false,
        stores: stores,
      }).then((res) => {
        this.dash = res.data;
      });
    },
    async getDash() {
      const response = await this.getdash({
        isByName: false,
        start: true,
        isTime: false,
      });

      if (response.data.length > 0) {
        this.dash = response.data;
      }
    },
    getTime() {
      this.getdash({
        isTime: true,
        isByName: false,
        start: false,
        comeco: this.dateStartFilter,
        end: this.dateEndFilter,
        stores: this.getSelectedStores,
      }).then((res) => {
        this.dash = res.data;
        this.allFilterTypes(this.getFilterTypes);
        this.filterPhrase = this.selectedFilterType;
      });
    },
    async getCommets() {
      const response = await this.getcommets({
        isByName: false,
        start: true,
        isTime: false,
      });

      if (response.data) {
        this.comments = response.data;
      }
    },
    getCommetsTime() {
      this.getcommets({
        isTime: true,
        isByName: false,
        start: false,
        comeco: this.dateStartFilter.toISOString(),
        end: this.dateEndFilter.toISOString(),
      }).then((res) => {
        this.comments = res.data;
      });
    },
    async getCommetsFilter(stores) {
      let newArr = stores.slice(0, barrel);
      let arr = this.paramsReportXls(newArr);

      await this.getcommets({
        isByName: true,
        start: false,
        isTime: false,
        stores: arr,
      }).then((res) => {
        this.comments = res.data;
      });
    },
    async getStories() {
      const response = await this.getstory({
        start: true,
      });

      if (response.data) {
        this.story = response.data;
      }
    },
    async getmediaFilter(stores) {
      let newArr = stores.slice(0, barrel);
      let arr = this.paramsReportXls(newArr);

      await this.getmedia({
        isByName: true,
        start: false,
        isTime: false,
        stores: arr,
      }).then((res) => {
        this.medias = res.data;
      });
    },
    async getstoryFilter(stores) {
      let arr = this.paramsReportXls(stores);
      await this.getstory({
        isByName: true,
        start: false,
        stores: arr,
      }).then((res) => {
        this.story = res.data;
      });
    },
    getStoryTime() {
      this.getstory({
        isTime: true,
        isByName: false,
        start: false,
        comeco: this.dateStartFilter,
        end: this.dateEndFilter,
        stores: this.getSelectedStores,
      }).then((res) => {
        this.story = res.data;
      });
    },
    getReport() {
      apiGerenciarMidias
        .getxls({
          stores: this.getSelectedStores,
          inicio: this.dateStartFilter,
          fim: this.dateEndFilter,
        })
        .then((response) => {
          if (response.data) {
            let blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              }),
              url = window.URL.createObjectURL(blob);
            window.open(url);
          } else {
            console.log("Não foi possível realizar o download do relatorio!!!");
          }
        })
        .catch((err) => console.error(err));
    },
    currentDateTime(timestamp) {
      return moment(timestamp).locale("pt-br").subtract(3, "hour").calendar();
    },
    paramsReportXls(arr) {
      let arrString = "";

      for (let [i, store] of arr.entries()) {
        if (store != undefined) {
          if (i === 0) {
            arrString = `${store}`;
          } else {
            arrString = `${arrString}&instaPageId=${store}`;
          }
        }
      }
      return arrString;
    },
    allFilterTypes(newValue) {
      switch (newValue.type) {
        case "24":
          this.selectedFilterType = "nas últimas 24h";
          break;
        case "7":
          this.selectedFilterType = "nos últimos 7 dias";
          break;
        case "30":
          this.selectedFilterType = "nos últimos 30 dias";
          break;
        case "personalizado":
          if (newValue.date.start != newValue.date.end) {
            this.selectedFilterType = `do dia ${moment(
              newValue.date.start
            ).format("DD/MM/YYYY")} até ${moment(newValue.date.end).format(
              "DD/MM/YYYY"
            )}`;
          } else {
            this.selectedFilterType = `do dia ${moment(
              newValue.date.start
            ).format("DD/MM/YYYY")}`;
          }
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style scoped>
#div-dashboard {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
}

.main {
  margin-top: 82px;
}

.card-dash {
  width: 90%;
  padding: 16px 40px 6px 40px;
  background-color: var(--white);
  border-radius: 8px;
  box-shadow: 0px 24px 38px rgba(9, 15, 37, 0.07);
}

.p-card {
  color: #80848a;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
}

.h2-card {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
}

.por-card {
  color: #2cbf59 !important;
  background: rgba(44, 191, 89, 0.1);
  border-radius: 8px;
  font-size: 13px;
  padding: 3px;
}

.por-card-red {
  color: #e51717 !important;
  background: rgba(229, 23, 23, 0.1);
  border-radius: 8px;
  font-size: 13px;
  padding: 3px;
}

.btn-comment {
  color: #2485ea;
  font-family: "Roboto";
}

.btn-dash {
  color: #2485ea;
  background: #d3e7fb;
  border-radius: 8px;
  padding: 8px;
}

.btn-card {
  color: #2485ea;
  border: none;
  border-radius: 8px;
  background: #d3e7fb;
  padding: 8px 20px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
}

.interogacao-col-2 {
  position: absolute;
  margin-top: -10px;
  margin-left: 17%;
}

.interogacao-col {
  margin-top: -10px;
  margin-left: 100%;
}

.p-comentario {
  color: #80848a;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
}

.short-text {
  max-width: 35ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media only screen and (max-width: 410px) {
  #label-attach-image {
    font-size: 13px;
    padding: 12px 14px;
  }
}

@media only screen and (max-width: 700px) {
  #section-personal-data > div,
  #section-security > div {
    flex-direction: column;
  }

  .input-confirm-new-password-responsive,
  .input-new-password-responsive {
    margin: 0;
  }

  .card-dash {
    width: 100%;
    padding: 16px 40px 6px 40px;
    background-color: var(--white);
    border-radius: 8px;
    box-shadow: 0px 24px 38px rgba(9, 15, 37, 0.07);
    margin-top: 10px;
  }
}

@media only screen and (max-width: 768px) {
  .session-one {
    flex-direction: column;
  }

  #section-security {
    margin: 12px 0 0 0;
  }

  #section-personal-data {
    margin: 0 0 12px 0;
  }
}

.a-vermais {
  color: rgb(36, 133, 234);
  margin-left: 45%;
  font-size: 14px;
  font-weight: 450;
  font-family: "Roboto";
  font-style: normal;
  cursor: pointer;
}
</style>
